module.exports = __webpack_public_path__ + "img/songlei.8f2ee584.jpg";